import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jbdmkbs59: FaireProductEntity = {
  token: "p_8jbdmkbs59",
  type: "product",
  name: "Mahjong Birthday Card Greeting Card | Good Luck Card",
  brandToken: "b_8vbjw4gshg",
  brandName: "Abigail Jayne Design",
  imageUrl:
    "https://cdn.faire.com/fastly/0c1753458430801dba1fcf4b3b53d024c1a19ce3a15e09393f5accfd2f7e57d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/554a373c6a195125cc28d9b76912f4914900cde5c93b99423a76455b8b1b14bc.jpeg",
    "https://cdn.faire.com/fastly/e82875ea38f598b17f754d464e6a673af4111ced195651d96d67488d57dbca98.png",
    "https://cdn.faire.com/fastly/ed59f5514ceebfbad70a12bcc9bd8e39ab8aa73b9bc5e61f6f3ec13f526430f8.png",
  ],
  priceDollars: 3,
  description:
    '• Beautiful hand-painted original watercolor Mahjong birthday card\n• A2 (4.25" x 5.5")\n• Digital print on a quality, felt textured card\n• Gold foil accents\n• 100% recycled kraft envelope\n• Packaged in a clear sleeve\n• Folded card\n• Blank interior\n• Printed in the USA',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:46.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
